<template>
  <div id="top">
    <div v-if="isLoadingJobAds || isLoadingPosts || !isFullLoad" :class="isMobileResolution ? $style.stopUserEventsMobile : $style.stopUserEvents"></div>
    <!-- <button @click="test" >Test</button> -->
    <!-- Убрать стиль и будет видно кнопку -->
    <b-card class="custom-card">
      <b-row>
        <b-col>
          <h5 class="header2">{{$t('text11')}}</h5>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col>
          <circle-button :iAmArtist="true" :selectButton="isLookingJob" @click="isLookingJob=true"/>
        </b-col>
        <b-col>
          <circle-button :iAmArtist="false" :selectButton="!isLookingJob" @click="isLookingJob=false"/>
        </b-col>
      </b-row> -->
      <select-skills @live-update-selected-skills="selectedSkill=$event" :data="{selectedSkill: selectedSkill, selectedSkills: selectedSkills, onlySelect: true}"/>
      <b-row v-if="!(isLoadingJobAds || isLoadingPosts || !isFullLoad)">
        <b-col cols="12" class="show-result-block">
          <button class="btn btn-info btn-fill btn-wd" @click="callJobAdsApi">{{$t('showResult')}}</button>
        </b-col>
      </b-row>
      <b-row v-if="isLoadingJobAds || isLoadingPosts || !isFullLoad" style="justify-content: center; margin-top: 10px;">
        <sync-loader class="text-center" color="red"></sync-loader>
      </b-row>
    </b-card>
    <span id="element"></span>
    <div v-if="!(jobAdsList.length || posts.postsList.length) && sendRequestAds && sendRequestPosts && !(isLoadingPosts || isLoadingJobAds || !isFullLoad)" style="text-align: center;">{{$t('noFind')}}...</div>
    <b-tabs v-if="posts.postsList.length || jobAdsList.length" content-class="mt-3 container-fluid" class="rating-tab" v-model="resIndex">
      <b-tab title="Universtage">
        <div v-if="!posts.postsList.length && sendRequestPosts" style="text-align: center;">{{$t('noFind')}}...</div>
        <div v-if="posts.postsList.length" class="post-container">
          <gallery :input="posts.postsList" :index="indexImg" @close="indexImg = null"></gallery>
          <b-row class="card card-post" v-for="(post, postIndex) in posts.postsList" :key="postIndex" :id="'post'+postIndex">
            <router-link :to="{name: 'profile', params: {id: post.users.id}}">
              <div style="width: 100%;">
                <img :src="post.users.avatar" class="image-avatar"/>{{post.users.firstName}} {{post.users.lastName}}
              </div>
            </router-link>
            <div class="col-md-12 disable-col-padding status-post">
              <div v-if="post.participantType === 1"><i class="fa fa-check fa-post"></i>{{$t('availableForContract')}}</div>
              <div v-if="post.participantType !== 1"><i class="fa fa-search fa-post"></i> {{$t('lookingFor')}}</div>
            </div>
            <div class="col-md-12 disable-col-padding">
              <div v-if="post.artistTypesList.length" class="skills-post">
                <p v-for="(skill, index) in post.artistTypesList" :key="index">{{getSkillString(skill)}}</p>
              </div>
              <div class="row">
                <div class="col-md-10" v-if="post.href">
                  <div v-for="(text,index) in post.localeTextsList" :key="index" class="message-post">
                    {{text.text}}
                  </div>
                </div>
                <div class="col-md-12" v-if="!post.href">
                  <div v-for="(text,index) in post.localeTextsList" :key="index" class="message-post">
                    {{text.text}}
                  </div>
                </div>
                <div class="col-md-2 disable-col-padding-l enable-col-padding-m" v-if="post.href">
                  <div class="image post-image" v-if="post.href" 
                    @click="indexImg = postIndex" 
                    :style="{ backgroundImage: 'url(' + post.href + ')'}">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-8" v-if="post.date_start">
                  <div class="date-post">
                    <i class="fa fa-calendar-o fa-post"></i> {{onlyDate(post.date_start)}}{{post.date_end ? ` - ${onlyDate(post.date_end)}` : ''}}
                  </div>
                </div>
                <div class="col-md-6 col-8" v-if="!post.date_start"></div>
                <div class="col-md-6 col-4">
                  <div class="location-post date text-right">
                    {{$t('created')}} {{dateFormatter(post.created)}}
                  </div>
                </div>
                <div class="col-md-12" v-if="post.googlePlace">
                  <div class="location-post">
                    <i class="fa fa-map-marker fa-post"></i> {{post.googlePlaceLocales && post.googlePlaceLocales[currentLng] && post.googlePlaceLocales[currentLng].formatted_address}}
                  </div>
                </div>
              </div>
            </div>
          </b-row>
          <b-pagination v-if="posts.maxPage>1" v-model="posts.currentPage" :total-rows="posts.allPostsCount" :per-page="posts.countPerPage" size="md" align="center" @input="setPage"/>
        </div>
      </b-tab>
      <b-tab :title="$t('jobAds')">
        <div v-if="!jobAdsList.length && sendRequestAds && selectedSkill && selectedSkill.artistType" style="text-align: center;">{{$t('noFind')}}...</div>
        <!-- <div v-if="!jobAdsList.length && sendRequestAds && (!selectedSkill || !selectedSkill.artistType)" style="text-align: center;">{{$t('noFind')}}...<br/>{{$t('text36')}}</div> -->
        <div v-if="!jobAdsList.length && sendRequestAds" style="text-align: center;">{{$t('noFind')}}...</div>
        <div v-if="jobAdsList.length && (realEmail ? true : false) && allResults" style="text-align: center;">
          {{$t('sendEmail')}}
          <b-button size="sm" variant="outline-danger" @click="sendtToEmail"><i class="fa fa-envelope"></i></b-button>
        </div>
        <div v-if="jobAdsList.length" style="padding: 20px;">
          <b-row v-for="(post,index) in viewJobAdsList" :key="index">
            <hr/>
            <div :class="$style.postText" style="width: 100%">{{post.message}}</div>
            <div :class="$style.postLabel" style="width: 100%">{{$t('text31')}}:</div>
            <a :href="post.postLink" target="_blank" style="max-width: 100%; word-wrap: break-word;">{{post.postLink}}</a>
          </b-row>
          <br>
          <b-pagination v-if="jobAdsList.length>5" v-model="jobAdsListCurrentPage" :total-rows="jobAdsList.length" :per-page="5" size="md" align="center" @input="setPageJobAds"/>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import CircleButton from './CircleButton'
  import SelectSkills from "./SelectSkills"
  import { mapActions, mapGetters } from 'vuex';
  import syncLoader from 'vue-spinner/src/PulseLoader.vue'
  import {GET_JOB_ADS} from "../store/actions/skillsConst";
  import {POSTS_LOAD_COUNT,POSTS_LOAD_BB,USER_AVATAR_LOAD,POSTS_LOAD_IMAGE} from "../store/actions/userConst";
  import {GOOGLE_GET_PLACE} from "../store/actions/langConst"
  import gallery from 'gallery-vue';
  import swal from 'sweetalert2'
  var moment = require('moment');
  moment().format();

  export default {
    name: 'BB_JobAds',
    components: { CircleButton, SelectSkills, syncLoader, gallery },
    watch: {
      isFullLoad(val) {
        if(val) {
          this.$emit('preLoadJobAds', this.getUserProfile)
        }
      }
    },
    computed: {
      ...mapGetters(['isLoadingPosts','isLoadingJobAds','realEmail','getUserProfile','currentLng','RxLng','getSkills','getArtistTypes','isMobileResolution']),
      isFullLoad() {
        return (this.getUserProfile && this.getUserProfile.id && this.getSkills.length && this.getArtistTypes.length) ? true : false;
      },
    },
    mounted() {
      this.$on('preLoadJobAds', this.preLoadJobAds);
      if(this.isFullLoad) {
        this.$emit('preLoadJobAds', this.getUserProfile)
      }
    },
    data() {
      return {
        allResults: true,
        preLoadJobAdsCount: 0,
        cacheAvatars: [],
        cacheImage: [],
        indexImg: null,
        resIndex: 0,
        isLookingJob: true,
        selectedSkills: [],
        selectedSkill: null,
        viewJobAdsList: [],
        jobAdsList: [],
        jobAdsListCurrentPage: 1,
        sendRequestAds: false,
        sendRequestPosts: false,
        posts: {
          countPerPage: 5,
          _allPostsCount: 0,
          _currentPage: 1,
          get allPostsCount() { 
            return this._allPostsCount 
          },
          set allPostsCount(value) { 
            this._allPostsCount = value < 0 ? 0 : value;
            this.maxPage = parseInt(this._allPostsCount/this.countPerPage) + ((this._allPostsCount % this.countPerPage)?1:0)
          },
          get currentPage() { return this._currentPage },
          set currentPage(value) {
            this._currentPage = value < 1 ? 1 : (value > this.maxPage ? this.maxPage : value);
          },
          maxPage: 0,
          where: {and: []},
          postsList: [],
        },
      }
    },
    methods: {
      ...mapActions([GET_JOB_ADS,POSTS_LOAD_COUNT,POSTS_LOAD_BB,USER_AVATAR_LOAD,GOOGLE_GET_PLACE,POSTS_LOAD_IMAGE]),
      test() {
        // this.$emit('test',12345678);
        console.log(this.preLoadJobAdsCount);
        console.log(this.getUserProfile.artistTypesList.length);
        console.log(this.preLoadJobAdsCount>=this.getUserProfile.artistTypesList.length);
        console.log(this.jobAdsList && this.jobAdsList.length);
        // console.log(this.selectedSkill);
        // console.log(this.getUserProfile);
      },
      preLoadJobAds(user) {
        if(!(user.userCategory=='artist' || user.userCategory=='team') || !user.artistTypesList || !user.artistTypesList.length || this.preLoadJobAdsCount>=user.artistTypesList.length) return;
        if(this.jobAdsList && this.jobAdsList.length) {
          this.preLoadJobAdsCount = user.artistTypesList.length;
          return;
        }
        this.selectedSkill = {};
        this.selectedSkill.artistType = this.getArtistTypes.find(a=>a.id==user.artistTypesList[this.preLoadJobAdsCount].artistTypeId);
        if(this.selectedSkill.artistType) {
          this.selectedSkill.categories = this.selectedSkill.artistType.categories.find(c=>c.name_en==user.artistTypesList[this.preLoadJobAdsCount].categories);
        }
        this.selectedSkill.skill = this.getSkills.find(s=>s.code==user.artistTypesList[this.preLoadJobAdsCount].skill);
        this.preLoadJobAdsCount++;
        this.callJobAdsApi();
      },
      sendtToEmail() {
        let data = {
          email: this.realEmail,
          firstName: this.getUserProfile.firstName,
          skill: (this.selectedSkill && this.selectedSkill.skill) ? this.selectedSkill.skill.skill_en : null,
          performerTypeName: (this.selectedSkill && this.selectedSkill.artistType) ? this.selectedSkill.artistType.type_en: null,
          category: (this.selectedSkill && this.selectedSkill.categories) ? this.selectedSkill.categories.name_en : null,
          // participantType: this.isLookingJob ? 1 : 2,
          participantType: this.getUserProfile && this.getUserProfile.id && (this.getUserProfile.userCategory == 'artist' || this.getUserProfile.userCategory == 'team') ? 1 : 2,
          languageId: this.currentLng,
        }
        for(let key in data) {
          if(!data[key]) delete data[key]
        }
        if(this.selectedSkill && this.selectedSkill.artistType) {
          this.GET_JOB_ADS(data)
            .then(()=>{
              const Toast = swal.mixin({
                toast: true,
                position: 'bottom-start',
                customClass: 'sweet-modal',
                showConfirmButton: false,
                timer: 3000
              });
              Toast.fire({
                title: '<i class="fa fa-check fa-2x"></i>' + this.$t('jobs_email_sent')
              });
            })
            .catch(err=>console.log(err))
        }
      },
      updateGooglePlace() {
        this.posts.postsList.forEach(post=>{
          if(post.googlePlace) {
            post.googlePlaceLocales = post.googlePlaceLocales || {}
            if(!post.googlePlaceLocales[this.currentLng]) {
              this.GOOGLE_GET_PLACE({place_id: post.googlePlace, language: this.currentLng, fields: ['formatted_address']})
                .then(place=>{
                  post.googlePlaceLocales[this.currentLng]=place
                  this.posts.postsList.push({})
                  this.posts.postsList.splice(this.posts.postsList.length-1,1)
                })
                .catch(err=>console.log(err))
            }
          }
        })
      },
      updateAvatarCache() {
        this.posts.postsList.forEach(element => {
          if(element.users) {
            if(!~this.cacheAvatars.findIndex(c=>c.id===element.usersId)) {
              this.cacheAvatars.push({id: element.usersId})
            }
          } else {
            element.users = {}
            element.users.firstName = 'Unknow'
            element.users.lastName = 'User'
          }
          if(element.imageId && !~this.cacheImage.findIndex(c=>c.id===element.id)) {
            this.cacheImage.push({id: element.id, imageId: element.imageId})
          }
        })
        this.cacheAvatars.forEach(c => {
          if(!c.avatar) {
            this.USER_AVATAR_LOAD(c)
              .then((img)=>{
                c.avatar = img
                this.posts.postsList.filter(p=>p.usersId===c.id).forEach(p1=>p1.users.avatar=c.avatar)
                this.posts.postsList.push({})
                this.posts.postsList.splice(this.posts.postsList.length-1,1)
              })
              .catch((err)=>console.log(err))
          } else {
            this.posts.postsList.filter(p=>p.usersId===c.id).forEach(p1=>p1.users.avatar=c.avatar)
            this.posts.postsList.push({})
            this.posts.postsList.splice(this.posts.postsList.length-1,1)
          }
        })
        this.cacheImage.forEach(c => {
          if(!c.href) {
            this.POSTS_LOAD_IMAGE(c.imageId)
              .then((img)=>{
                c.href = img
                this.posts.postsList.filter(p=>p.id===c.id).forEach(p1=>p1.href=c.href)
                this.posts.postsList.push({})
                this.posts.postsList.splice(this.posts.postsList.length-1,1)
              })
              .catch((err)=>console.log(err))
          } else {
            this.posts.postsList.filter(p=>p.id===c.id).forEach(p1=>p1.href=c.href)
            this.posts.postsList.push({})
            this.posts.postsList.splice(this.posts.postsList.length-1,1)
          }
        })
      },
      dateFormatter(date) {
        return moment(date).format('DD.MM.YYYY');
      },
      onlyDate(date) {
        let buf = new Date(date)
        return buf.toLocaleString('ru',{day: 'numeric', month: 'numeric', year: 'numeric'})
      },
      getSkillString(skill) {
        let aType = this.getArtistTypes.find(t=>t.id===skill.artistTypeId)
        if(aType) {
          let aCat = aType.categories.find(c=>c.name_en===skill.categories)
          if(aCat) {
            let aSkill = this.getSkills.find(s=>s.code===skill.skill)
            if(aSkill) {
              return `${aType['type_'+this.currentLng]} -> ${aCat['name_'+this.currentLng]} -> ${aSkill['skill_'+this.currentLng]}`
            } else {
              console.log(`Ненайден skill артиста с code=${skill.skill}`)
            }
          } else {
            console.log(`Ненайдена категория артиста с ID=${skill.artistTypeId} name_en=${skill.categories}`)
          }
        } else {
          console.log(`Ненайден тип артиста с ID=${skill.artistTypeId}`)
        }
        return 'Error!'
      },
      setPageJobAds() {
        this.viewJobAdsList = [];
        for (let index = 0; index < 5; index++) {
          if((this.jobAdsListCurrentPage-1)*5+index<this.jobAdsList.length)
            this.viewJobAdsList.push(this.jobAdsList[(this.jobAdsListCurrentPage-1)*5+index]);
        }
        if(!this.isLoadingPosts && this.resIndex) {this.$scrollTo('#element', 1000, { container: '#scroll' })}
      },
      setPage() {
        this.$scrollTo('#top', 1000, { container: '#scroll' })
        this.POSTS_LOAD_BB({where: this.posts.where, skip: (this.posts.currentPage-1)*this.posts.countPerPage, limit: this.posts.countPerPage})
          .then(res=>{
            this.posts.postsList = res.posts;
            this.updateAvatarCache();
            this.updateGooglePlace();
            this.$scrollTo('#element', 1000, { container: '#scroll' });
          })
          .catch(err=>console.log(err))
      },
      callJobAdsApi() {
        let data = {
          // email: this.sendEmail ? this.realEmail : null,
          // firstName: this.sendEmail ? this.getUserProfile.firstName : null,
          skill: (this.selectedSkill && this.selectedSkill.skill) ? this.selectedSkill.skill.skill_en : null,
          performerTypeName: (this.selectedSkill && this.selectedSkill.artistType) ? this.selectedSkill.artistType.type_en: null,
          category: (this.selectedSkill && this.selectedSkill.categories) ? this.selectedSkill.categories.name_en : null,
          // participantType: this.isLookingJob ? 1 : 2,
          participantType: this.getUserProfile && this.getUserProfile.id && (this.getUserProfile.userCategory == 'artist' || this.getUserProfile.userCategory == 'team') ? 1 : 2,
          languageId: this.currentLng,
        }
        for(let key in data) {
          if(!data[key]) delete data[key]
        }
        this.allResults = this.selectedSkill && this.selectedSkill.artistType ? true : false;
        // if(this.selectedSkill && this.selectedSkill.artistType) {
          this.GET_JOB_ADS(data)
            .then(res=>{
              this.jobAdsList=res
              this.$emit('preLoadJobAds', this.getUserProfile)
              // this.resIndex = !this.posts.allPostsCount && this.jobAdsList.length ? 1 : 0; 
              this.resIndex = this.jobAdsList.length ? 1 : 0; 
              this.sendRequestAds = true;
              this.jobAdsListCurrentPage = 1;
              this.setPageJobAds();
            })
            .catch(err=>{
              console.log(err)
              this.sendRequestAds = true;
              this.$emit('preLoadJobAds', this.getUserProfile);
            })
        // } else {
        //   this.jobAdsList = [];
        //   this.sendRequestAds = true;
        // }
        this.posts.where.and = [{participantType: {neq: data.participantType}}];
        if(this.selectedSkill && this.selectedSkill.artistType) { this.posts.where.and.push({'artistTypesList.artistTypeId': {eq: this.selectedSkill.artistType.id}}) }
        if(this.selectedSkill && this.selectedSkill.categories) { this.posts.where.and.push({'artistTypesList.categories': {eq: this.selectedSkill.categories.name_en}}) }
        if(this.selectedSkill && this.selectedSkill.skill) { this.posts.where.and.push({'artistTypesList.skill': {eq: this.selectedSkill.skill.code}}) }
        this.POSTS_LOAD_COUNT({where: this.posts.where})
          .then(res=>{
            this.posts.allPostsCount = res.allPostsCount;
            this.posts.currentPage = 1;
            this.POSTS_LOAD_BB({where: this.posts.where, skip: 0, limit: this.posts.countPerPage})
              .then(res=>{
                this.sendRequestPosts = true;
                this.posts.postsList = res.posts;
                // this.resIndex = !this.posts.allPostsCount && this.jobAdsList.length ? 1 : 0; 
                if(!this.isLoadingJobAds && !this.resIndex) {this.$scrollTo('#element', 1000, { container: '#scroll' })}
                this.updateAvatarCache();
                this.updateGooglePlace();
              })
              .catch(err=>console.log(err))
          })
          .catch(err=>console.log(err))
      },
    },
  }
</script>

<style lang="scss" module>
  .stopUserEvents {
    position: fixed;
    top: -10000px;
    left: 260px;
    width: 20000px;
    height: 20000px;
    z-index: 999999;
  }
  .stopUserEventsMobile {
    position: fixed;
    top: -10000px;
    left: 0px;
    width: calc(100% - 100px);
    height: 20000px;
    z-index: 999999;
  }
  .buttonDisabled {
    cursor: not-allowed !important;
  }
</style>

<style scoped>
  .show-result-block {
    text-align: center;
    margin-bottom: 5px;
    margin-top: 25px;
  }
  .header2 {
    text-align: center;
    font-family: "Roboto", "Helvetica Neue", Arial, sans-serif !important;
    color: #565656;
    margin-bottom: 25px;
  }
  .post-container {
    padding: 20px;
  }
  .card-post {
    padding: 20px;
    margin-bottom: 20px;
    color: #565656 !important;
  }
  .card-post .control-btn {
    position: absolute;
    right: 0px;
  }
  .card-post .btn-outline-danger {
    margin-right: 3px;
  }
  .card-post .status-post {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .card-post .status-post .fa {
    margin-right: 5px;
  }
  .card-post .skills-post { 
    background-color: white; 
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    padding: 10px;
    margin-top: 10px;
    max-height: 100px; 
    overflow-y: auto;
  }
  .card-post .skills-post::-webkit-scrollbar {
      width: 8px
  }
  .card-post .skills-post p { 
    margin-bottom: 5px;
  }
  .card-post .message-post {
    background-color: white; 
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    padding: 10px;
    margin-top: 10px;
    height: 100px; 
    overflow-y: auto;
  }
  .card-post .date-post,
  .card-post .location-post {
    margin-top: 10px;
  }
  .card-post .fa-map-marker {
    font-size: 20px;
    padding-right: 3px;
  }
  .card-post .fa-post {
    color: #474747 !important;
    padding-right: 5px;
  }
  .image {
      float: left;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      border: 1px solid #ebebeb;
      margin-top: 10px;
  }
  .post-image {
      width: 100% !important;
      height: 100px;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;
  }
  .image-avatar {
      width: 50px;
      height: 50px;
      border-radius: 100px;
      border: 1px solid #eee;
      margin-right: 10px;
  }
  .invisibleButton {
    background: transparent;
    border: none !important;
    font-size:0;
  } 
  .card.custom-card {
    border: none !important;
  }
  hr {
  /* border: 0; */
  /* clear:both; */
  /* display:block; */
  width: 100%;               
  background-color:rgb(187, 183, 183);
  /* height: 1px; */
}
</style>